<template>
  <div class="featured-article" :class="{ padding: fields?.featuredpadding?.value === true }">
    <div class="featured-article__image">
      <sc-image v-if="fields && fields.image" :media="fields.image" />
    </div>
    <div class="featured-article__content">
      <sc-text class="label" v-if="fields && fields.label" :field="fields.label" />
      <sc-text
        tag="h3"
        class="featured-article__title"
        v-if="fields && fields.title"
        :field="fields.title"
      />
      <sc-richText
        class="featured-article__intro"
        v-if="fields && fields.intro"
        :field="fields.intro"
      />
      <sc-link
        v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
        :field="fields.cta"
        class="c-cta--primary"
        :class="fields.cta.value.class"
        >{{ fields?.cta?.value?.text }}
        <span class="sr-only">{{ fields?.title?.value }}</span></sc-link
      >
      <sc-link
        v-if="fields && fields.link && fields.link.value && fields.link.value.text"
        :field="fields.link"
        class="featured-article__link"
        :class="fields.link.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, RichText, Image, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Featured-Article',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScImage: Image,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-article {
  height: 100%;

  &:not(.padding) {
    &:deep() {
      .featured-article__image {
        @include desktop-up {
          min-width: 33rem;
        }
      }
    }
  }

  &.padding {
    .featured-article__image {
      padding: 2rem;
      background: $box-gray;
      display: flex;

      @include desktop-up {
        max-width: 47.5rem;
      }

      img {
        object-fit: contain;
      }
    }
  }

  &:deep() {
    display: flex;
    position: relative;
    @include add-Shadow;
    margin: auto auto 2rem;
    max-width: 100%;

    @include tablet-down {
      flex-wrap: wrap;
      margin: 0 0 2rem 0;
    }

    .featured-article__image {
      width: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;

        @include tablet-up {
          max-height: none;
        }
      }
    }

    .featured-article__content {
      position: relative;
      padding: 4.5rem 2rem 2rem 2.2rem;

      @include desktop-up {
        padding: 5.4rem 2.4rem 2rem 2.4rem;
      }

      .label {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        background-color: $dark-blue;
        border-radius: 0;
        font-weight: 500;
        font-size: 1.4rem;
        line-height: 1.6rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;
        padding: 0.6rem 0.8rem 0.6rem 1rem;
      }

      .featured-article__title {
        @include font-styles('Arial', 2.5rem, 200, normal, normal, 0, $dark-blue);
        text-transform: capitalize;
        margin-bottom: 1rem;

        @include desktop-up {
          font-size: 2.8rem;
          line-height: 3.5rem;
          margin-bottom: 0.5rem;
        }
      }

      .featured-article__intro {
        @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $dark-blue);
        margin-bottom: 2rem;

        @include desktop-up {
          font-size: 2rem;
          line-height: 2.6rem;
        }
      }

      .featured-article__link {
        display: block;
        @include font-styles('Arial', 1.4rem, 600, normal, 2rem, 0, $blue);
        text-decoration: underline;
      }
    }
  }
}

.c-site__main {
  a.c-cta--primary {
    width: 100%;
    margin-bottom: 1rem;

    @include desktop-up {
      width: auto;
    }
  }
}
</style>
